export const profile = {
  profileFavoritesIconTitle: 'Favoriter',
  profileEditIconTitle: 'Redigera',
  profileShareIconTitle: 'Dela',
  profileAdditionalSectionTitle: 'Ytterligare information',
  profileFavoritesCurtainTitle: 'Favoriter',
  profileFavoriteActionTitle: 'Favorit',
  profileFavoritedActionTitle: 'Tillagd i favoriter',
  profileMessageAction: 'Meddelande',
  profileCurtainAdd: 'Lägg till',
  profileReportUser: 'Rapportera användare',
  profileReportTitle: 'Rapportera',
  profileReportSuccess: 'Innehållet har rapporterats',
  profileReset: 'Återställ',
  profileApply: 'Tillämpa',
  profileCustomInvalidEmail: 'är inte en giltig e-postadress',
  profileMaxContentSizeError: 'Du har överskridit maximal innehållsstorlek!',
  profileMaxAvatarSizeError: 'Din avatarstorlek är för stor!',
  profileFavoritesCurtainSearchInputText: 'Sök',
  profileTapShareCurtainOptionTitle: 'Kopiera länk',
  profileTapShareLinkCopiedAlertTitle: 'Länk kopierad!',
  profileQrShareCurtainTitle: 'Dela profil',
  profileQrShareCurtainShareButtonTitle: 'Dela',
  profileQrShareCurtainCopyButtonTitle: 'Kopiera länk',
  profileQrShareCurtainCopiedAlertTitle: 'Länk kopierad!',
  profileQrTapShareProfileCurtainTitle: 'Dela din profil',
  profileEditTitle: 'Redigera',
  profileEditPersonalSectionTitle: 'Personuppgifter',
  profileEditContactsSectionTitle: 'Kontakter',
  profileEditSocialSectionTitle: 'Sociala medier',
  profileEditAddSocialButtonTitle: 'Lägg till sociala medier',
  profileEditAdditionalSectionTitle: 'Ytterligare information',
  profileEditSaveButtonTitle: 'Spara',
  profileEditSavedAlertTitle: 'Profilen är sparad!',
  profileEditEmptyRequiredInputTitle: 'Värdet kan inte vara tomt',
  profileEditEmptyRequiredEmailInputTitle: 'Offentlig e-postadress är inte giltig',
  profileEditEmptyRequiredErrorTitle: 'Något gick fel!',
  profileEditSocialsHint: 'Vänligen skriv in URL:en till din sociala profil',
  preferences: 'Inställningar',
  interestedIn: 'Intresserad av',
  expertIn: 'Jag är expert på',
  myPitch: 'Min pitch',
  qrBadge: 'QR Badge',
  touchpoints: 'Touchpoints',
  lookingFor: 'Jag söker',
  topicsToDiscuss: 'Ämnen att diskutera',
  createNew: 'Skapa ny',
  viewTopic: 'Visa ämne',
  hobbyInterests: 'Hobby & Intressen',
  myNetwork: 'Mitt nätverk',
  seeAll: 'Visa alla',
  checkThemOut: 'Kolla in dem!',
  activities: 'Aktiviteter',
  oneOnOne: '1:1 Möte',
  Leaderboard: 'Leaderboard',
  learnNetworking: 'Läs mer om Networking Hub',
  networkingGroup: 'Networking Grupp',
  networkingLevel: 'Networking Nivå',
  addNote: 'Lägg till anteckning',
  notes: 'Anteckningar',
  enterNote: 'Ange en anteckning',
  shareUserProfile: 'Dela användarprofil',
  flagUser: 'Rapportera användare'
}
